module.exports = {"ingredientsMenuMargin":"30px"};